import { render, staticRenderFns } from "./Invitacion.vue?vue&type=template&id=5299c66e&scoped=true"
import script from "./Invitacion.vue?vue&type=script&lang=js"
export * from "./Invitacion.vue?vue&type=script&lang=js"
import style0 from "./Invitacion.vue?vue&type=style&index=0&id=5299c66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299c66e",
  null
  
)

export default component.exports